<template>
    <div>
        <div v-if="isShow&&type !== 'company'&&type !== 'school'">
            <div class="select">
                <el-form ref="form" :model="form" label-width="150px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="专业名称：">
                                <input type="text" v-model="queryParams.majorName" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="专业代码：">
                                <input type="text" v-model="queryParams.majorCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="主考学校名称：">
                                <input type="text" v-model="queryParams.mainSchoolName" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="授予学位：">
                                <input type="text" v-model="queryParams.degreeName" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="招生专业编码：">
                                <input type="text" v-model="queryParams.enrollMajorCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="课程组代码：">
                                <input type="text" v-model="queryParams.courseGroupCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="主考学校代码：">
                                <input type="text" v-model="queryParams.mainSchoolCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="培养层次：">
                                <el-select
                                    v-model="queryParams.eduLevel"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in teachers"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="btn">
                <button
                    style="background-color: #409eff; border: 0; color: #fff"
                    @click="handleSearch"
                >
                    确认
                </button>
                <button @click="isShow = false">收起</button>
                <button @click="handleReset">清空</button>
            </div>
        </div>
        <div class="selectbtn">
            <button
                @click="isShow = true"
                style="background-color: #409eff; border: 0; color: #fff"
                v-if="type !== 'company'&&type !== 'school'"
            >
                筛选
            </button>
            <button @click="handleExport"  style="cursor:pointer;background-color: #409eff;border: 0; color: #fff">导出结果</button>
        </div> 
    </div>
</template>

<script>
export default {
  props:['type'],
    data() {
        return {
            isShow: false,
            // 时间
            teachers: [
                {
                  label: "-不限-",
                  value: "",
                },
                {
                  label: "本科",
                  value: "3",
                },
                {
                  label: "专科",
                  value: "4",
                },
            ],
            teacher: "-不限-",
            queryParams: {
              majorName:'',
              majorCode:'',
              mainSchoolName:'',
              mainSchoolCode:'',
              degreeName:'',
              enrollMajorCode:'',
              courseGroupCode:'',
              eduLevel:''
            },
            form: {},
        };
    },
    methods:{
      /** 搜索事件 */
      handleSearch(){
        this.$emit('change',this.queryParams)
      },
      /** 重置事件 */
      handleReset(){
        // this.resetForm('form');
        this.queryParams = {
          majorName:'',
          majorCode:'',
          mainSchoolName:'',
          mainSchoolCode:'',
          degreeName:'',
          enrollMajorCode:'',
          courseGroupCode:'',
          eduLevel:''
        }
        this.$emit('change',this.queryParams)
      },
      /** 导出结果 */
      handleExport(){
        this.$emit('export',this.queryParams)
      }
    }
};
</script>

<style lang="scss" scoped>
input {
    display: inline-block;
    width: 206px;
    height: 32px;
    border: 1px solid #c0c4cc;
    border-radius: 5px;
}
.el-row {
    font-size: 16px;
}
.btn {
    text-align: center;
}
button {
    width: 73px;
    height: 28px;
    border: 1px solid #000;
    border-radius: 5px;
    margin: 0 20px;
}
.selectbtn {
    width: 100%;
    height: 55px;
    line-height: 65px;
    margin: 10px 0;
    background-color: #f2f2f2;
    position: relative;
}
</style>